import {
  SAVE_IN_TEMP_CONVERTOR_REDUCER,
  SAVE_TEMP_COUPON_CODE,
  SAVE_TRANSACTION_DETAILS,
  MULTI_TXN_RECIPIENT_LIST,
  MULTI_TXN_CURRENT_BENE,
  MULTI_TXN_RECIPIENT_LIST_TEMP_ID,
  MULTI_TXN_INITIATE_TXN,
  MULTI_TXN_CLEAR_RECIPIENT,
  MULTI_TXN_CLEAR_RECIPIENT_EXCEPT_INITIALISED_TXN,
  SET_CORPORATE_CONFIG,
  UPDATE_RECIPIENT_LIST,
  STORE_FROM_VAL_TO_EDIT,
  SET_COUPON_DATA,
  REPLACE_RECIPIENT_LIST_ITEM,
  STORE_PAYMENT_METHOD,
  DISABLE_SUBMIT_BUTTON,
  SAVE_BENE_DATA,
  SAVE_SELECTED_BENE_DATA,
  AML_CHECK_ADDED,
  SAVE_SELECTED_CASHPICK_UP,
  CLEAN_SELECTED_CASHPICK_UP,
  STORE_CASHPICK_UP_RESPONSE,
  STORE_RECENT_ADDED_BENE,
  SBM_REFERRAL_TRANSACITION_CONSENT_ADDED,
  ADD_INSTAPOINTS,
  ADD_REFERRAL_REWARD,
  SAVE_UPSELLING_CMS_POPUP_CONTENTS,
  SAVE_TRANSACTION_COMPARISON_DETAILS,
  SAVE_NEW_COUPON_CODE,
  TOGGLE_NEW_COUPON_CODE_APPLIED,
  SAVE_NEW_COUPON_AMOUNT,
  SAVE_MIN_SOURCE_AMOUNT_FOR_COUPON,
  SAVE_COUPON_CMS_DATA,
  SAVE_COUPON_DATA,
  SAVE_NON_FORMATTED_COUPON_DATA,
  SAVE_PROMOTIONS_CMS_CONTENTS,
  SAVE_SELECTED_CONFIG_BENE_VALIDATIONS,
  SAVE_SELECTED_SCHEMA_BENE_VALIDATIONS,
  STORE_DHA_CHALLAN_DATA
} from '../../action-contants';
import { API_URL } from '../../../utils/config';
import { handleError, showMessage } from '../common-message/message-action';
import { getAccountType, makeApiCall } from '../common/common-action';
import {
  combineTempIdWithDetails,
  generatePayloadToSubmitBatch,
  deleteRecipientTransactionFromList,
  editRecipientListWith,
  getBatchNumber
} from '../../../utils/multiple-transactions/multiple-transactions';
import { CORPORATE, HIGH_VALUE_TRANSACTION } from '../../../utils/constants';
import cloneDeep from 'lodash/cloneDeep';
import {
  getThresholdLimit,
  getUniqueSessionId,
  isCurrencyPairInTierList
} from '../../../utils/library';
import { storeHelpcenterNotificationData } from '../user-state/user-state-action';
import { store } from '../../../store';
import { get } from 'lodash';
import { getFlagValue, isFlagEnabled } from '../flagsmith';

export function saveTransactionDetails(data) {
  return {
    type: SAVE_TRANSACTION_DETAILS,
    data
  };
}

export function saveUpsellingCMSPopupDetails(data) {
  return {
    type: SAVE_UPSELLING_CMS_POPUP_CONTENTS,
    data
  };
}
export function saveTempConverterData(data) {
  return {
    type: SAVE_IN_TEMP_CONVERTOR_REDUCER,
    data
  };
}

export const savePromotionsCMSData = (data) => {
  return {
    type: SAVE_PROMOTIONS_CMS_CONTENTS,
    data
  };
};

export function storeBeneList(data) {
  return {
    type: SAVE_BENE_DATA,
    data
  };
}
export function storeSelectedBeneList(data) {
  return {
    type: SAVE_SELECTED_BENE_DATA,
    data
  };
}
export function storeConfigBeneValidation(data) {
  return {
    type: SAVE_SELECTED_CONFIG_BENE_VALIDATIONS,
    data
  };
}
export function storeSchemBeneValiation(data) {
  return {
    type: SAVE_SELECTED_SCHEMA_BENE_VALIDATIONS,
    data
  };
}
export function selectedCashPickup(data) {
  return {
    type: SAVE_SELECTED_CASHPICK_UP,
    data
  };
}
export function cleanSelectedCashPickUp(data) {
  return {
    type: CLEAN_SELECTED_CASHPICK_UP,
    data
  };
}
export function storeCashPickUpFromResponse(data) {
  return {
    type: STORE_CASHPICK_UP_RESPONSE,
    data
  };
}
function setCorpConfig(data) {
  return {
    type: SET_CORPORATE_CONFIG,
    data
  };
}
export function storeFormForEdit(data) {
  return {
    type: STORE_FROM_VAL_TO_EDIT,
    data
  };
}
export function storeCouponData(data) {
  return {
    type: SET_COUPON_DATA,
    data
  };
}

export function saveRateComparisonDetails(data) {
  return {
    type: SAVE_TRANSACTION_COMPARISON_DETAILS,
    data
  };
}

export function createTempTransaction() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/pm-relief-fund/quick-transaction`,
        withCredentials: true
      });
      if (response && response.data && response.data.success && response.data.data) {
        dispatch(saveTransactionDetails(response.data.data));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

export function validateCouponCode(data) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/batch/validate-coupon`,
        withCredentials: true,
        data
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

const showDisclaimerFn = (response) => {
  let showDisclaimer = false;
  try {
    const showDisclaimerArray = response.map((paymentMethod) => {
      const hasAsterisk = paymentMethod['payment_method_limit'];

      if (hasAsterisk?.includes('*')) return true;
      return false;
    });

    if (showDisclaimerArray.some((ele) => ele === true)) {
      showDisclaimer = true;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('errors in disclaimer', error);
  }
  return showDisclaimer;
};
/** to show notes on dashboard and sendMoney screens, i.e ACH notes */
export function paymentMethodResponse(response) {
  const showDisclaimer = showDisclaimerFn(response);
  return {
    type: STORE_PAYMENT_METHOD,
    response,
    showDisclaimer
  };
}

export function disableSubmit(value) {
  return {
    type: DISABLE_SUBMIT_BUTTON,
    value
  };
}
export function initiateTransaction() {
  return async (dispatch, getState) => {
    let transaction = getState().rootReducer.transactionReducer.transactionDetails;
    let data = {
      source_currency: transaction.source_currency,
      destination_currency: transaction.destination_currency,
      session_id: getUniqueSessionId(),
      is_aml_declaration_accepted: transaction.is_aml_checked || null
    };

    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/transaction/${transaction.temp_transaction_id}/initiate`,
        withCredentials: true,
        data
      });
      // Reset coupon data once initiate transfer is successful
      if (response?.data?.success) {
        dispatch(toggleNewCouponCode(false));
        const dhaChallanData = getState().rootReducer.userFlowReducer?.dhaChallanData;
        if (dhaChallanData?.challan_number) {
          dispatch({ type: STORE_DHA_CHALLAN_DATA, data: null });
        }
      }
      dispatch(saveTransactionDetails(response.data.data));
      return response;
    } catch (error) {
      dispatch(handleError(error));
      throw error;
    }
  };
}

export function saveSbmReferralTransactionConsent() {
  return async (dispatch, getState) => {
    let transaction = getState().rootReducer.transactionReducer.transactionDetails;
    let data = {
      sbm_referral_transaction_consent: transaction.sbm_referral_transaction_consent || null
    };

    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/transaction/${transaction.temp_transaction_id}/sbm-referral-consent`,
        withCredentials: true,
        data
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getPlaidAccounts(redirect_url = '') {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: `${API_URL}/plaid/account${redirect_url}`,
        withCredentials: true
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function authenticatePlaid({ public_token, meta_data, type }) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/plaid/auth`,
        withCredentials: true,
        data: {
          publicToken: public_token,
          metaData: meta_data,
          ...type
        }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function on3dsTransactionComplete(payload, transaction_id) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/transaction/${transaction_id}/vendor-transaction`,
        withCredentials: true,
        data: payload
      });
    } catch (error) {
      await dispatch(handleError({ ...error, is3dsFailedError: true }));
    }
  };
}

export function logPlaidDetails(dataObj) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/plaid/log`,
        withCredentials: true,
        data: {
          ...dataObj
        }
      });
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getTransactionDetails(id, isIndividual, isTransactionHistoryPage = false) {
  return async (dispatch) => {
    try {
      let url = isIndividual ? `${API_URL}/transaction/info` : `${API_URL}/batch/info`;
      let data = isIndividual ? { transaction_number: id } : { batch_number: id };
      let response = await makeApiCall({
        url,
        data,
        method: 'post',
        withCredentials: true
      });
      if (!isTransactionHistoryPage) {
        if (isIndividual) dispatch(saveTransactionDetails(response.data.data));
        else dispatch(saveInitiateTransactionResp(response.data.data));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export function getTempTransactionPreSelected(transactionId) {
  return async (dispatch) => {
    try {
      let url = `${API_URL}/transaction/${transactionId}/pre-selected-meta`;
      let response = await makeApiCall({
        url,
        method: 'get',
        withCredentials: true
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getPoliTransactionDetails(token, isIndividual) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/poli/transaction`,
        withCredentials: true,
        data: {
          token: token
        }
      });
      if (isIndividual) dispatch(saveTransactionDetails(response.data.data));
      else dispatch(saveInitiateTransactionResp(response.data.data));
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export const checkBeneAccountVerification = (beneId) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/remitter/beneficiary/${beneId}/account-verification`,
        withCredentials: true
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      if (error.response.status === 460) {
        return {
          success: false,
          isAccountVerificationError: true,
          data: error.response.data?.data
        };
      }
      if (error.response.status === 461) {
        return { success: false, isNameVerificationError: true, data: error.response.data?.data };
      }
      if (error.response.status === 451) {
        return {
          success: false,
          isBankVerificationUnavailable: true,
          data: error.response.data?.data,
          errorCode: error.response.status
        };
      }
      dispatch(handleError(error));
    }
  };
};

export function getEghlTransactionDetails(paramObj, isIndividual) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/eGHL/transaction`,
        withCredentials: true,
        data: paramObj
      });
      if (isIndividual) dispatch(saveTransactionDetails(response.data.data));
      else dispatch(saveInitiateTransactionResp(response.data.data));
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getWorldpayTransactionDetails(paramObj, isIndividual) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/worldpay/transaction`,
        withCredentials: true,
        params: paramObj
      });
      if (isIndividual) dispatch(saveTransactionDetails(response.data.data));
      else dispatch(saveInitiateTransactionResp(response.data.data));
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}
export function newTransactionComputation(params, config = {}) {
  return async (dispatch, getState) => {
    //for multi txn, bene id is required for bene level transaction error handling
    let accountType = dispatch(getAccountType()),
      beneficiary_id = null,
      formData = getState().form.multipleTransactions;
    const selecetedBeneID =
      getState().rootReducer.transactionReducer.multiTxnCurrentBene &&
      getState().rootReducer.transactionReducer.multiTxnCurrentBene.beneficiary_id;
    const countryCode = getState().rootReducer?.userStatusReducer?.country_code || '';

    const thresholdValues = getFlagValue(HIGH_VALUE_TRANSACTION);
    const hvtThresholdLimit = getThresholdLimit(
      thresholdValues,
      countryCode,
      params.source_currency
    );

    if (isCurrencyPairInTierList(params.source_currency, params.destination_currency)) {
      params.get_comparisons = true;
      params.get_upsell = null;
    } else if (
      isFlagEnabled(HIGH_VALUE_TRANSACTION) &&
      params.source_amount >= hvtThresholdLimit?.thresholdLimit
    ) {
      params.get_comparisons = true;
      params.get_upsell = null;
    }

    const selectedBankAccountId =
      getState().rootReducer.transactionReducer.multiTxnCurrentBene &&
      getState().rootReducer.transactionReducer.multiTxnCurrentBene.instarem_bank_account_id;
    if (accountType === CORPORATE && formData && formData.values.beneficiary_id) {
      beneficiary_id = selecetedBeneID ? selecetedBeneID : formData.values.beneficiary_id;
      const instarem_bank_account_id = selectedBankAccountId
        ? selectedBankAccountId
        : params.instarem_bank_account_id;
      params = { ...params, beneficiary_id, instarem_bank_account_id };
    }

    const reduxStore = store.getState();
    const prevUpsellOfferDetails = get(
      reduxStore,
      'rootReducer.transactionReducer.transactionDetails.upsell_offer_details',
      null
    );
    const previousSlabFromAmount =
      prevUpsellOfferDetails?.[0]?.offer_discount_details?.slab_from_amount;

    const instapoints =
      getState().rootReducer.transactionReducer.transactionDetails.redeemed_instapoints;
    if (instapoints) {
      params = { ...params, instapoints };
    }

    const { updateTransactionDetails = true } = config;

    // DHA bene: always compute using destination amount (challan amount)
    const dhaChallanData = getState().rootReducer.userFlowReducer.dhaChallanData;
    if (dhaChallanData?.challan_number) {
      const challanAmount = parseFloat(String(dhaChallanData.amount));
      params = { ...params, source_amount: null, destination_amount: challanAmount };
    }

    try {
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/transaction/computed-value`,
        withCredentials: true,
        params
      });

      if (response && response.data && response.data.success && response.data.data) {
        if (updateTransactionDetails) {
          dispatch(
            saveTransactionDetails({
              ...response.data.data,
              instarem_bank_account_id: params.instarem_bank_account_id,
              upsell_offer_details:
                params.source_amount >= previousSlabFromAmount
                  ? prevUpsellOfferDetails
                  : response.data.data.upsell_offer_details
            })
          );
        }

        let { destination_validation, source_validation } = response.data.data;
        dispatch(
          saveTempConverterData({
            sourceErr: source_validation,
            DestinationErr: destination_validation
          })
        );
        dispatch(storeCouponData(false));
        return response.data.data;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
    return null;
  };
}

export function newTransactionComputationComparison(params) {
  return async (dispatch, getState) => {
    try {
      const {
        rootReducer: {
          transactionReducer: { comparisonDetails: data, transactionDetails } = {}
        } = {}
      } = getState();
      const {
        destinationCurrency,
        sourceCountry,
        sourceCurrency,
        instaremBankAccountId,
        beneficiaryId
      } = params;

      if (
        destinationCurrency === data?.destination_currency &&
        sourceCountry === data?.source_country &&
        sourceCurrency === data?.source_currency &&
        instaremBankAccountId === transactionDetails?.instarem_bank_account_id &&
        beneficiaryId === transactionDetails?.selectedBene.beneficiary_id
      ) {
        return data;
      }

      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/transaction/computation/comparison`,
        withCredentials: true,
        params
      });
      if (response?.data?.success) {
        const responseData = response?.data?.data;
        dispatch(saveRateComparisonDetails(responseData));
        return responseData;
      }
    } catch (error) {
      dispatch(handleError(error));
      return null;
    }
  };
}

export function defaultTransactionValues(country_code) {
  return async (dispatch) => {
    try {
      //When it becomes common write this in component
      let url = `${API_URL}/country/default-configuration`;
      if (country_code) {
        url = url + `?country_code=${country_code}`;
      }
      let response = await makeApiCall({
        method: 'get',
        url: url,
        withCredentials: true
      });
      if (response && response.data && response.data.data) return response.data.data;
    } catch (error) {
      dispatch(handleError(error));
    }
    return {};
  };
}

function transactionObjectMapper(transactionData) {
  return {
    /**
     * Transaction Details FOR Receipt
     */
    coupon_amount: transactionData.coupon_amount,
    coupon_code: transactionData.coupon_code,
    coupon_id: transactionData.coupon_id,
    destination_amount: transactionData.destination_amount,
    destination_currency: transactionData.destination_currency,
    fx_provider: transactionData.fx_provider,
    fx_rate: transactionData.fx_rate,
    gross_source_amount: transactionData.gross_source_amount,
    instarem_fx_rate: transactionData.instarem_fx_rate,
    margin_amount: transactionData.margin_amount,
    margin_percent: transactionData.margin_percent,
    net_of_fee_amount: transactionData.net_of_fee_amount,
    net_source_amount: transactionData.net_source_amount,
    net_tax_amount: transactionData.net_tax_amount,
    reason_for_transfer: transactionData.reason_for_transfer,
    redeemed_instapoints: transactionData.redeemed_instapoints,
    redeemed_instapoints_amount: transactionData.redeemed_instapoints_amount,
    redeemed_referral_rewards: transactionData.redeemed_referral_rewards,
    redeemed_referral_reward_amount: transactionData.redeemed_referral_reward_amount,
    source_currency: transactionData.source_currency,
    source_of_funds: transactionData.source_of_funds,
    tax_amount_1: transactionData.tax_amount_1,
    tax_amount_2: transactionData.tax_amount_2,
    tax_amount_3: transactionData.tax_amount_3,
    tax_type_1: transactionData.tax_type_1,
    tax_type_2: transactionData.tax_type_2,
    tax_type_3: transactionData.tax_type_3,
    temp_transaction_id: transactionData.temp_transaction_id,
    transaction_created_at: transactionData.transaction_created_at,
    transaction_cin: transactionData.transaction_cin,
    transaction_fee_amount: transactionData.transaction_fee_amount,
    transaction_fee_percent: transactionData.transaction_fee_percent,
    payment_method_fee_amount: transactionData.payment_method_fee_amount,
    beneficiary_card_details: transactionData.beneficiary_card_details,
    beneficiary_routing_config_type: transactionData.beneficiary_routing_config_type,
    transaction_config: {
      total_fee_amount: transactionData.total_fee_amount
    },

    /**
     * Details for payment method page
     */
    instarem_bank_account_id: transactionData.instarem_bank_account_id,
    remitter_bank_id: transactionData.remitter_bank_id,
    beneficiary_id: transactionData.beneficiary_id,
    notes: transactionData.notes,

    /**
     * Recipient Details FOR Payment review page
     */
    first_name: transactionData.beneficiary_first_name,
    last_name: transactionData.beneficiary_last_name,
    full_name:
      transactionData.beneficiary_account_type === 'CORPORATE'
        ? transactionData.beneficiary_company_name
        : transactionData.beneficiary_full_name,
    bank_name: transactionData.beneficiary_bank_name,
    bank_account_number: transactionData.beneficiary_bank_account_number,
    bank_branch: transactionData.bank_branch,
    beneficiary_country_name: transactionData.beneficiary_country_name,
    beneficiary_routing_code_type_1: transactionData.beneficiary_routing_code_type_1,
    beneficiary_routing_code_value_1: transactionData.beneficiary_routing_code_value_1,
    beneficiary_routing_code_type_2: transactionData.beneficiary_routing_code_type_2,
    beneficiary_routing_code_value_2: transactionData.beneficiary_routing_code_value_2,
    beneficiary_routing_code_type_3: transactionData.beneficiary_routing_code_type_3,
    beneficiary_routing_code_value_3: transactionData.beneficiary_routing_code_value_3,
    beneficiary_address: transactionData.beneficiary_address,

    /**
     * Added keys for visa card - 14/08/2019 (Divyanshu)
     */
    beneficiary_card_number: transactionData.beneficiary_card_number,

    /**
     * Added keys for geo swift card - (Divyanshu)
     */
    beneficiary_card_issuer_name: transactionData.beneficiary_card_card_issuer_name,
    additional_info: transactionData.additional_info,

    /**
     * Payment Details FOR Payment review page
     */
    display_name: transactionData.instarem_bank_account_display_name,
    is_pg: transactionData.instarem_bank_account_is_pg,
    remitter_bank_name: transactionData.remitter_bank_name,

    /**
     * Additional details for Acknowledgement page
     */
    payment_method: transactionData.instarem_bank_account_display_name,
    instarem_bank_account_name: transactionData.instarem_bank_account_name,
    instarem_bank_account_number: transactionData.instarem_bank_account_number,
    instarem_bank_account_routing_code_details:
      transactionData.instarem_bank_account_routing_code_details,
    instarem_bank_name: transactionData.instarem_bank_name,
    instarem_bank_address: transactionData.instarem_bank_address,
    client_email: transactionData.client_email,
    client_mobile_country_code: transactionData.client_mobile_country_code,
    client_mobile_number: transactionData.client_mobile_number
  };
}

export function getPaymentReviewDetails() {
  return async (dispatch, getState) => {
    try {
      let temp_transaction_id =
        getState().rootReducer.transactionReducer.transactionDetails.temp_transaction_id;
      let response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/transaction/${temp_transaction_id}/payment-review`,
        withCredentials: true
      });
      dispatch(saveTransactionDetails(transactionObjectMapper(response.data.data)));
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function setupQuickpayTransaction(transaction_number) {
  return async (dispatch) => {
    let onSuccess = (response) => {
      if (response && response.data && response.data.success)
        dispatch(saveTransactionDetails(response.data.data));
      return response;
    };
    let onError = (error) => {
      dispatch(handleError(error));
      throw error;
    };
    try {
      const success = await makeApiCall({
        method: 'post',
        url: `${API_URL}/transaction/quick-pay`,
        withCredentials: true,
        data: {
          transaction_number
        }
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

export function setTempCouponCode(coupon_code) {
  return (dispatch) => {
    dispatch({
      type: SAVE_TEMP_COUPON_CODE,
      data: coupon_code
    });
  };
}

//Multiple Transactions
export function multiTxnRecipientList(data) {
  return {
    type: MULTI_TXN_RECIPIENT_LIST,
    data: cloneDeep(data)
  };
}
export function multiTxnCurrentBene(data) {
  return {
    type: MULTI_TXN_CURRENT_BENE,
    data
  };
}

function saveRecipientListWithTempId(data) {
  return {
    type: MULTI_TXN_RECIPIENT_LIST_TEMP_ID,
    data
  };
}

export const saveNewCouponCode = (data) => {
  return {
    type: SAVE_NEW_COUPON_CODE,
    data
  };
};

export const toggleNewCouponCode = (data) => {
  return {
    type: TOGGLE_NEW_COUPON_CODE_APPLIED,
    data
  };
};

export const saveCouponData = (data) => {
  return {
    type: SAVE_COUPON_DATA,
    data
  };
};
export const saveNonFormattedCouponData = (data) => {
  return {
    type: SAVE_NON_FORMATTED_COUPON_DATA,
    data
  };
};
export const saveCMSCouponData = (data) => {
  return {
    type: SAVE_COUPON_CMS_DATA,
    data
  };
};
export const saveNewCouponAmount = (data) => {
  return {
    type: SAVE_NEW_COUPON_AMOUNT,
    data
  };
};

export const saveMinSourceAmountForCoupon = (data) => {
  return {
    type: SAVE_MIN_SOURCE_AMOUNT_FOR_COUPON,
    data
  };
};

export function deleteTransactionWithBeneId(data) {
  return {
    type: MULTI_TXN_RECIPIENT_LIST,
    data
  };
}

export function saveInitiateTransactionResp(data) {
  return {
    type: MULTI_TXN_INITIATE_TXN,
    data
  };
}

export function clearMultipleRecipients() {
  return (dispatch) => {
    dispatch({
      type: MULTI_TXN_CLEAR_RECIPIENT
    });
    return {};
  };
}

export function clearMultipleRecipientsExceptInitialisedTxn() {
  return (dispatch) => {
    dispatch({
      type: MULTI_TXN_CLEAR_RECIPIENT_EXCEPT_INITIALISED_TXN
    });
    return {};
  };
}

function removeUnnecessaryKeysFromPayload(data) {
  return data.map((val) => {
    delete val.beneficiary_routing_config_id_bank;
    delete val.beneficiary_routing_config_id_debit;
    delete val.show_bank_details_block;
    return val;
  });
}

export function submitMultiTxn(originalDetails, payLoad, batch_number) {
  return async (dispatch) => {
    try {
      let url = API_URL + '/batch/send-money';
      if (batch_number) url += `/${batch_number}`;
      let response = await makeApiCall({
        url,
        data: removeUnnecessaryKeysFromPayload(payLoad),
        method: 'post',
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        if (response.data.data) {
          let recipientListWithDetails = combineTempIdWithDetails(
            originalDetails,
            response.data.data
          );
          dispatch(saveRecipientListWithTempId(recipientListWithDetails));
        }
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function deleteTransactionWithTempId(tempTxnId, index) {
  return async (dispatch, getState) => {
    try {
      let recipientList =
        getState().rootReducer.transactionReducer.multipleTransactions.recipientList;
      if (tempTxnId) {
        let response = await makeApiCall({
          url: API_URL + `/transaction/${tempTxnId}`,
          method: 'post',
          withCredentials: true
        });
        if (response && response.data && response.data.success) {
          if (response.data.data) {
            let data = deleteRecipientTransactionFromList(
              recipientList,
              response.data.data.temp_transaction_id
            );
            let totalYouPayAmount = data.reduce(
              (acc, obj) => acc + obj.payload.net_source_amount,
              0
            );
            dispatch(multiTxnRecipientList({ recipientList: data, totalYouPayAmount }));
            return data;
          }
        } else {
          dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
          return false;
        }
      } else {
        let data = deleteRecipientTransactionFromList(recipientList, null, index);
        let totalYouPayAmount = data.reduce((acc, obj) => acc + obj.payload.net_source_amount, 0);
        dispatch(multiTxnRecipientList({ recipientList: data, totalYouPayAmount }));
        return data;
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function editTransaction(recipientData, recipientListFromRedux, tempTxnId, index) {
  return async (dispatch) => {
    try {
      if (tempTxnId) {
        let payload = generatePayloadToSubmitBatch([recipientData]),
          url = API_URL + `/batch/send-money/${tempTxnId}`;
        let data = payload.map((item) => {
          delete item.bank_account_country;
          delete item.currency_code;
          delete item.account_type;
          return item;
        });
        let response = await makeApiCall({
          url,
          data: { ...data[0] },
          method: 'patch',
          withCredentials: true
        });
        if (response && response.data && response.data.success) {
          if (response.data.data) {
            let { data } = response.data;
            let recipientList = editRecipientListWith({
              recipientListFromRedux,
              currentRecipientData: recipientData,
              saveData: data,
              tempTxnId: data[0].temp_transaction_id
            });
            let totalYouPayAmount = recipientList.reduce(
              (acc, obj) => acc + obj.payload.net_source_amount,
              0
            );
            dispatch(multiTxnRecipientList({ recipientList, totalYouPayAmount }));
          }
        } else {
          dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
        }
        return response;
      } else {
        let recipientList = editRecipientListWith({
          currentRecipientData: recipientData,
          recipientListFromRedux,
          index
        });
        let totalYouPayAmount = recipientList.reduce(
          (acc, obj) => acc + obj.payload.net_source_amount,
          0
        );
        dispatch(multiTxnRecipientList({ recipientList, totalYouPayAmount }));
      }
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function initiateBatchTransaction(batch_number) {
  return async (dispatch, getState) => {
    try {
      if (!batch_number) {
        let recipientList =
          getState().rootReducer.transactionReducer.multipleTransactions.recipientList;
        batch_number = getBatchNumber(recipientList);
      }
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/batch/${batch_number}/initiate`,
        withCredentials: true
      });
      if (response && response.data && response.data.data) {
        dispatch(saveInitiateTransactionResp(response.data.data));
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export function getCorpConfig() {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/config`,
        method: 'get',
        withCredentials: true
      });
      if (!response) return { message: 'no response' };
      if (response && response.data) {
        if (response.data.success) {
          dispatch(setCorpConfig(response.data.data));
          dispatch(storeHelpcenterNotificationData(response.data.data.help_center_notification));
        } else if (response.data.data && response.data.data.message) {
          dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
        }
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      let { response } = err;
      return response || err;
    }
  };
}

export const submitNiumForexRequest = (values) => {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        url: `${API_URL}/public/nium/forex`,
        method: 'post',
        data: values
      });
      return response;
    } catch (error) {
      dispatch(handleError(error));
    }
    return { success: false };
  };
};

export const pauseOrCancelRecurring = (configId, transferId, endpoint) => {
  return async (dispatch) => {
    try {
      const res = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/recurring-transfer/config/${configId}/transfer/${transferId}/${endpoint}`,
        withCredentials: true
      });
      return res;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
};

export function getRecurringTransferData(transferId) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/recurring-transfer/config/transfer/${transferId}`,
        withCredentials: true
      });
      if (response) return response?.data?.data;
    } catch (error) {
      dispatch(handleError(error));
    }
  };
}

export async function publicTransactionComputation(params, config = {}) {
  try {
    let response = await makeApiCall({
      method: 'get',
      url: `${API_URL}/public/transaction/computed-value`,
      withCredentials: true,
      params
    });
    return response?.data?.data;
  } catch (error) {
    if (config.failSilently) {
      throw error;
    }
    const message = error?.response?.data?.data?.message;
    if (message) {
      return message;
    } else {
      throw error;
    }
  }
}

//updating RecipientList
export function updateRecipientList(index, value) {
  return {
    type: UPDATE_RECIPIENT_LIST,
    data: {
      index,
      value
    }
  };
}

//updating RecipientList
export function replaceRecipientListItem(index, value) {
  return {
    type: REPLACE_RECIPIENT_LIST_ITEM,
    data: {
      index,
      value
    }
  };
}

export function setAMLCheck(value) {
  return {
    type: AML_CHECK_ADDED,
    data: value
  };
}

export function setSbmReferralConsent(value) {
  return {
    type: SBM_REFERRAL_TRANSACITION_CONSENT_ADDED,
    data: value
  };
}

export function storeRecentAddedBene(data) {
  return {
    type: STORE_RECENT_ADDED_BENE,
    data
  };
}

export const addInstapoints = (data) => {
  return {
    type: ADD_INSTAPOINTS,
    data
  };
};

export const addReferralReward = (data) => {
  return {
    type: ADD_REFERRAL_REWARD,
    data
  };
};
